import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import TagIcon from "@/utils/images/tagIcon";
import RemoveIcon from "@/utils/images/RemoveIcon";
import {
  getDiscountSettings,
  isDiscountEnabledForSelection,
  isDiscountCodeMatch,
  isDiscountExpired,
  isDiscountPopupMode,
} from "@/utils/discounts";

const DiscountInput = ({ marginTop }) => {
  const { handleSetDiscountCode, handleRemoveDiscountCode, discountCode, isSubscribe } = useCartData();
  const productData = useProductData();
  const [codeValue, setCodeValue] = useState("");
  const [error, setError] = useState("");
  const discountSettings = getDiscountSettings(productData, isSubscribe);
  const base = window?.post_template?.checkout_v4_summary;
  const discountsEnabledForSelection = isDiscountEnabledForSelection(productData, isSubscribe);

  // In popup mode the discount is applied from DiscountPopup, never typed in.
  if (!discountsEnabledForSelection || !discountSettings || isDiscountPopupMode(productData)) return null;

  const handleDiscountApply = () => {
    if (isDiscountCodeMatch(discountSettings, codeValue)) {
      if (isDiscountExpired(discountSettings)) {
        setError(base?.tr_checkout_v4_discount_expired);
        return;
      }
      handleSetDiscountCode(codeValue);
      setError("");
    } else {
      setError(base?.tr_checkout_v4_discount_error);
    }
    setCodeValue("");
  };

  const handleRemoveDiscount = () => {
    handleRemoveDiscountCode();
    setCodeValue("");
    setError("");
  };

  return (
    <>
      <div className="discount__inputContainer" style={{ marginTop: marginTop ?? "" }}>
        <div className={`discount__inputContainer__input input--text`}>
          <input
            className="discount__inputContainer__styledInput"
            value={codeValue}
            onChange={(e) => setCodeValue(e.target.value)}
            placeholder={base?.tr_checkout_v4_discount_placeholder}
          />
        </div>
        <button
          type="button"
          className="discount__inputContainer__applyButton"
          onClick={() => {
            codeValue && handleDiscountApply();
          }}
        >
          <span className="discount__inputContainer__applyButton__text">{base?.tr_checkout_v4_discount_apply}</span>
        </button>
      </div>
      {error && (
        <div className="discount__error" style={discountCode ? { marginBottom: "8px" } : {}}>
          {error}
        </div>
      )}
      <div className="discount__pill__container">
        {discountCode && (
          <div className="discount__pill">
            <TagIcon className="discount__pill__tag" />
            <span className="discount__pill__text">{discountCode}</span>
            <div className="discount__pill__closeBtn" onClick={handleRemoveDiscount}>
              <RemoveIcon />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DiscountInput;
